@if (!showDefaultLabel && !hideFloatingLabel) {
    <span class="floating-title caption-2">
        {{ defaultLabel }}
    </span>
}
<!-- nz-tooltip [nzTooltipTitle]="tooltip" nzTooltipPlacement="top" [nzTooltipMouseEnterDelay]="0.5" -->
<span>
    <button type="button" class="drop-down" nz-button nzType="default">
        @if (!!logo) {
            <img class="logo" [src]="logo" />
        }
        @if (showDefaultLabel) {
            <span [class.offset]="!!logo">{{ label }}</span>
        } @else {
            @for (item of selectionLabels; track item) {
                @if (item) {
                    <span [class.offset]="!!logo">{{ item }}</span>
                }
            }
        }
        @if (showDefaultLabel) {
            <adspt-icon [name]="isOpen ? 'caret-up' : 'caret-down'" />
        } @else {
            @if (!disableCloseIcon) {
                <adspt-icon class="close-icon" name="close-circle" (click)="$event?.stopPropagation(); closed.emit()" />
            }
            @if (disableCloseIcon) {
                <adspt-icon [name]="isOpen ? 'caret-up' : 'caret-down'" />
            }
        }
        @if (showLoader && (hasParams$ | async)) {
            <nz-spin></nz-spin>
        }
    </button>
</span>
